/**
 * Checks if the given argument is a function.
 * isFunction('x'); // false
 * isFunction(x => x); // true
 * @param val
 * @returns
 */
export const isFunction = val => typeof val === 'function';
